import React from "react";
import { Box, GlobalStyles } from "@mui/material";
import ServicesByTechnicianDetailedChart from "../components/ServicesByTechnicianDetailedChart";
import { THEME_COLORS } from "../utils/constants";
import { GLOBAL_DASH_STYLES } from "./Dashboard/dashboardTheme";
import { useDashboardData } from "./Dashboard/hooks/useDashboardData";
import DashboardHeader from "./Dashboard/components/DashboardHeader";
import MetricStrip from "./Dashboard/components/MetricStrip";
import ServicePipeline from "./Dashboard/components/ServicePipeline";
import ServicesTrendChart from "./Dashboard/components/ServicesTrendChart";
import ServicesTypeChart from "./Dashboard/components/ServicesTypeChart";
import InventoryAlerts from "./Dashboard/components/InventoryAlerts";
import FieldReportsOverview from "./Dashboard/components/FieldReportsOverview";

export default function Dashboard() {
  const {
    kpis,
    servicesByMonth,
    servicesByType,
    eventStats,
    fieldReportStats,
    lowStock,
    pipeline,
    pipelineTotal,
    completionRate,
    momChange,
    loading,
  } = useDashboardData();

  return (
    <>
      <GlobalStyles
        styles={{
          "html, body": {
            scrollbarColor: `${THEME_COLORS.primary} ${THEME_COLORS.background}`,
            scrollbarWidth: "thin",
          },
          "*::-webkit-scrollbar": { width: "6px", height: "6px" },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: "#c4c4c0",
            borderRadius: 8,
          },
        }}
      />
      <style>{GLOBAL_DASH_STYLES}</style>

      <Box className="dash-root">
        <DashboardHeader
          completionRate={completionRate}
          pipelineTotal={pipelineTotal}
          kpis={kpis}
          loading={loading}
        />

        <MetricStrip kpis={kpis} loading={loading} momChange={momChange} />

        <p className="dash-section-label">Operaciones</p>
        <ServicePipeline
          pipeline={pipeline}
          pipelineTotal={pipelineTotal}
          completionRate={completionRate}
          eventStats={eventStats}
          loading={loading}
        />

        <p className="dash-section-label">Análisis</p>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
            gap: 2,
            mb: 3,
          }}
        >
          <ServicesTrendChart data={servicesByMonth} loading={loading} />
          <ServicesTypeChart data={servicesByType} loading={loading} />
        </Box>

        <Box sx={{ mb: 3 }}>
          <ServicesByTechnicianDetailedChart />
        </Box>

        <p className="dash-section-label">Estado del sistema</p>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" },
            gap: 2,
          }}
        >
          <InventoryAlerts items={lowStock} loading={loading} />
          <FieldReportsOverview
            stats={fieldReportStats}
            eventStats={eventStats}
            loading={loading}
          />
        </Box>
      </Box>
    </>
  );
}
